export enum PermissionType {
    LECTURE = 'lecture',
    CREATION = 'creation',
    MODIFICATION = 'modification',
    SUPPRESSION = 'suppression',
}
